const flowSteps = {
  step: {
    1: 'Dados cadastrais',
    2: 'Conferir exames',
    3: 'Perguntas restritivas',
    4: 'Forma de pagamento (Convênio)',
    5: 'Forma de pagamento (Particular)',
    7: 'Autorizar convênio',
    8: 'Pagamento de exames',
    9: 'Assinatura de protocolos',
    10: 'Informar chegada na unidade',
    11: 'Responder questionário(s)',
    12: 'Pagamento',
    13: 'Selecionar exames'
  },

  status: {
    1: 'false',
    2: 'success',
  },
};

export default Object.freeze(flowSteps);
